<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card class="bg-light shadow">
          <b-card-title title-tag="h6"
            >Anomalies des mises à l'agenda</b-card-title
          >
          <b-button
            size="sm"
            icon
            title="Indiquer les notes comme lues"
            variant="success"
            v-if="numberOfNotesNoteRead > 0"
            @click="note_lues()"
            class="mb-3"
          >
            Indiquer les notes comme lues
          </b-button>
          <b-table
            v-if="agenda.length > 0 && loaded"
            id="agendaTable"
            striped
            small
            hover
            responsive
            :fields="fields"
            :items="agenda"
          >
            <template v-slot:cell(read)="data">
              <div v-html="toBadge(data.item.read)"></div>
            </template>
            <template v-slot:cell(mandatID)="data">
              <b-link
                :to="{
                  name: 'warrantView',
                  params: { id: data.item.mandatID },
                }"
                >{{ data.item.mandatID }}</b-link
              >
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import gestions from "@/services/gestion.js";
import warrants from "@/services/warrants.js";
//import DateTime from "@/services/DateTime.js";
export default {
  name: "Agenda",
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Anomalies des mises à l'agenda",
          active: true,
        },
      ],
      loaded: false,
      busy: true,
      numberOfNotesNoteRead: 0,
      agenda: [],
      myInterval: null,
      fields: [
        {
          key: "read",
          label: "",
          sortable: false,
          thStyle: "width:50px",
        },
        {
          key: "mandatID",
          label: "Mandat",
          sortable: true,
          class: "text-center",
        },
        {
          key: "when",
          label: "Date",
          sortable: true,
          class: "text-center",
        },
        {
          key: "content",
          label: "Contenu",
          sortable: false,
        },
      ],
    };
  },
created() {
    this.load(true);
    this.myInterval = setInterval(() => {
      this.load();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.myInterval);
  },
  methods: {
    toBadge(value) {
      if (value == "no") {
        return `<span class="badge badge-danger">Nouveau</span>`;
      }
      return "";
    },
    note_lues() {
      warrants
        .read_notes({ warrant_id: 'admin' })
        .then((response) => {
          if (response.data.success) {
            this.load();
          }
        });
    },
    load(busyState = false) {
      if (busyState) {
        this.busy = true;
      }
      gestions.agenda().then((response) => {
        this.agenda = response.data.data.agenda;
        this.loaded = true;
        this.busy = false;
        this.numberOfNotesNoteRead = this.agenda.filter(
            (x) => x.read == "no"
          ).length;
      });
    },
  },
};
</script>

